export class ItProjectEstimate {
  estimateType: string;
  dollarAmount: number;
  estimateIdentifier: string;
  hardwareSoftware: string;
  assetLocation: string;
  majorLocation: string;
  assetLocationId: string;
  majorLocationId: string;
  buType: string;
  uopDescription: string;
  utilityAccountId: string;
  utilityAccountDescription: string;
  retirementUnitId: string;
  retirementUnitDescription: string;
  quantity: number;
  chargeType: string;
  assetAndMajorLoaded: boolean;

  constructor(
    estimateType?: string,
    dollarAmount?: number,
    estimateIdentifier?: string,
    hardwareSoftware?: string,
    assetLocation?: string,
    majorLocation?: string,
    uopDescription?: string,
    quantity?: number,
    chargeType?: string,
    assetLocationId?: string
  ) {
    this.estimateType = estimateType;
    this.dollarAmount = dollarAmount;
    this.estimateIdentifier = estimateIdentifier;
    this.hardwareSoftware = hardwareSoftware;
    this.assetLocation = assetLocation;
    this.majorLocation = majorLocation;
    this.uopDescription = uopDescription;
    this.quantity = quantity;
    this.chargeType = chargeType;
    this.assetLocationId = assetLocationId;
    this.assetAndMajorLoaded = false;
  }
}
